<template>
    <span v-loading="loading">{{label}}</span>
</template>

<script>
/* コード値に対応するラベル表示 */
/* eslint-disable semi */
import { Component, Prop, Watch } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';
import * as sas from '@/core/decorators';

@Component
export default class AppLabelCode extends AppComponent {
  @Prop({ required: true })
  value;

  @Prop({ required: false, default: null })
  options;

  @sas.BindApi
  @sas.BindCache({ transparent: true })
  @sas.BindLoading({activeOn: ['fetch']})
  data () {
    return {
      loading: false,
      innerLabel: ''
    }
  }

  initialize () {
    this.fetch();
  }

  get label () {
    return this.innerLabel;
  }

  @Watch('value')
  @sas.Asynchronous
  fetch () {
    this.innerLabel = '';
    return this.fetchImpl()
      .then(result => {
        if (result) {
          this.innerLabel = result.label;
        }
      })
      .catch(reason => {
        this.ignore(reason);
      });
  }

  fetchImpl () {
    // 未定義・空の場合は検索を行わない
    if (this.value === undefined || this.value === null || this.value === '') {
      return Promise.resolve(null);
    }

    const cache = (this.options.global) ? this.$_sas.$cache.global : this.$_sas.$cache;
    const url = this.options.api.option;
    const params = {};
    params[this.options.api.paramName] = this.value;
    return cache.segment(url).get(params, () => {
      return this.$_sas.$api.cancel().get(url, { params })
        .then(response => {
          return response.data.results.codes;
        });
    });
  }

  focus () {
    // 例外スロー
    throw new Error('Can not set focus.');
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/label/AppLabelCode.vue